import {
  forwardRef,
  type ElementRef,
  type ComponentPropsWithoutRef,
} from 'react';
import { Root, Indicator } from '@radix-ui/react-checkbox';
import { Check } from '@/components/icons/barrel';
import { cn } from '@/utils/cn';

const OrderCheckbox = forwardRef<
  ElementRef<typeof Root>,
  ComponentPropsWithoutRef<typeof Root>
>(({ className, ...props }, ref) => (
  <Root
    ref={ref}
    className={cn(
      'peer h-5 w-5 shrink-0 border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-background',
      className,
    )}
    {...props}
  >
    <Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <Check className="h-4 w-4" />
    </Indicator>
  </Root>
));
OrderCheckbox.displayName = Root.displayName;

export { OrderCheckbox };
